import React, {useEffect} from 'react';
import {useDispatch} from "react-redux";
import {useForm} from "react-hook-form";
import {CheckPassword, CreateCancelButtons, InputMain} from "components";
import {authActions, httpRequestsOnSuccessActions} from 'store';
import {FindLoad, FindSuccess, PasswordValidator, usePrimaryModal} from "utils";
import {checkPassword} from "../auth/constants";
import {Svg} from "assets";

const ACTION_TYPE = 'RESET_PASSWORD_USER_EMPLOY'

export const ResetPassword = ({id, ifEmploy = false}) => {
    const dispatch = useDispatch()
    const {
        handleSubmit,
        control,
        watch,
    } = useForm();
    const {closePrimary} = usePrimaryModal();
    const loading = FindLoad(ACTION_TYPE);
    const success = FindSuccess(ACTION_TYPE)

    const passwordRules = !ifEmploy ? {
            required: "New password is required.",
            pattern: {
                value: PasswordValidator,
                message: "Not valid password",
            },
        } :

        {
            required: "New password is required.",
            minLength: {
                value: 4,
                message: "Password must be at least 4 characters.",
            },
            validate: (value) =>
                value.trim().length >= 4 || "Password must contain at least 4 non-space characters.",
        }

    useEffect(() => {
        if (success?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            closePrimary()
        }

    }, [success])

    const onSubmit = (data) => {
        if (id) {
            dispatch(authActions.resetPasswordUserEmploy(id, {password: data?.password}))
        }
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)} className='reset-password-for-admin-employ'>
            <div className="modal-header-main">
                <h3 className="modal-header-title">
                    Reset Password
                </h3>

                <button className="modal-close-btn-main" type="button" onClick={closePrimary}>
                    <Svg.CloseSvg/>
                </button>
            </div>

            <div className="modal-body-main">
                <div className="full-width">
                    <InputMain
                        variant="outlined"
                        name="password"
                        type="password"
                        control={control}
                        placeholder={"Create New Password"}
                        labelHeader={"Create New Password"}
                        minLength={!ifEmploy ? 8 : 4}
                        rules={passwordRules}
                        startAdornment={<Svg.LockPassSvg/>}
                    />

                    {!ifEmploy &&
                        <CheckPassword
                            fields={checkPassword}
                            text={watch("password")}
                            isActive={watch("password")}
                        />
                    }
                </div>

                <InputMain
                    variant="outlined"
                    name="confirmation"
                    type="password"
                    control={control}
                    placeholder={"Confirm New Password"}
                    labelHeader={"Confirm New Password"}
                    minLength={8}
                    rules={{
                        required: "Confirm password is required.",
                        validate: (value) => {
                            return value === watch("password") || 'Password and confirm password does not match'
                        }
                    }}
                    startAdornment={<Svg.LockPassSvg/>}
                />
            </div>

            <CreateCancelButtons
                createText={'Save'}
                onCancel={closePrimary}
                createBtnStyles={{width: '100%'}}
                cancelBtnStyles={{width: '100%'}}
                loading={!!loading?.length}
            />
        </form>
    );
};

